import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { BaseDto } from './base.dto';

export class MerchantTypeDto extends BaseDto {
  id: number;
  merchantGroup: MerchantGroupDto;
  merchantGroupId: number;
  managerUser?: MerchantDto[];
  name: string;
  startDate?: Date;
  endDate?: Date;
} 